"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftContextProvider = exports.useGiftContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var GiftContext = /*#__PURE__*/(0, _react.createContext)({
  user: {},
  contact: {}
});

var useGiftContext = function useGiftContext() {
  return (0, _react.useContext)(GiftContext);
};

exports.useGiftContext = useGiftContext;

var GiftContextProvider = function GiftContextProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(GiftContext.Provider, {
    value: value
  }, children);
};

exports.GiftContextProvider = GiftContextProvider;